import { render, staticRenderFns } from "./TableContainer.vue?vue&type=template&id=895fc196&"
import script from "./TableContainer.vue?vue&type=script&lang=js&"
export * from "./TableContainer.vue?vue&type=script&lang=js&"
import style0 from "./TableContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports